import { render, staticRenderFns } from "./article22.vue?vue&type=template&id=5c32f5aa&"
import script from "./article22.vue?vue&type=script&lang=js&"
export * from "./article22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports